import { render, staticRenderFns } from "./StatsOverdueDistributions.vue?vue&type=template&id=3990f3b4&"
import script from "./StatsOverdueDistributions.vue?vue&type=script&lang=js&"
export * from "./StatsOverdueDistributions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports